import { Box } from "@mui/system";
import ExpertPaymentCheckboxParent from "./ExpertPaymentCheckboxParent";
import ExpertPaymentActions from "./ExpertPaymentActions";

export default function ExpertPaymentHeaderCell({ selectedUserIds, handleClearState, allSelected, someSelected, onToggleAll }) {
    const showActions = selectedUserIds.length > 0;

    return (
        <Box sx={styles.container}>
            <Box
                sx={{
                    ...styles.actionsContainer,
                    visibility: showActions ? "visible" : "hidden",
                }}
            >
                <Box sx={styles.count}>{selectedUserIds.length} Selected</Box>
                <ExpertPaymentActions
                    selectedUserIds={selectedUserIds}
                    handleClearState={handleClearState}
                />
            </Box>
            <Box sx={styles.checkboxContainer}>
                <ExpertPaymentCheckboxParent
                    allSelected={allSelected}
                    someSelected={someSelected}
                    onToggleAll={onToggleAll}
                />
            </Box>
        </Box>
    );
}

const styles = {
    container: {
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
    },
    actionsContainer: {
        width: "120px",
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
    },
    count: {
        marginRight: "15px",
    },
    checkboxContainer: {
        marginLeft: "15px",
    },
};
